module.exports = __webpack_public_path__ + "assets/img/left-big.725597ec.svg";